'use client';
import React, { useRef } from 'react';
import CardTour from './CardTour';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa6';
import { App_text } from '@/settings/AppText';

export default function RelatedPost({ data = [], postType }) {
    const navigationPrevRef = useRef(null);
    const navigationNextRef = useRef(null);

    // Function to get the correct display text based on postType
    const getDisplayText = () => {
        switch (postType) {
            case 'activities':
                return 'excursions';
            case 'tours':
                return 'tours';
            case 'city_breaks':
                return 'city breaks';
            default:
                return postType;
        }
    };

    return (
        data.length !== 0 && (
            <div className="relative flex flex-col gap-8">
                <hr className="mt-4" />
                <div className="flex flex-col items-center justify-between md:flex-row">
                    <div className="default-color-title custom-style-h2">
                        {App_text.generale.title_related_single} {getDisplayText()}
                    </div>
                    <div className="relative items-center hidden gap-2 mb-4 lg:flex md:mb-0 ">
                        <span ref={navigationPrevRef} className="p-3 text-gray-600 transition-colors bg-white border rounded-full cursor-pointer hover:bg-main-color hover:text-white">
                            <FaAngleLeft className="w-4 h-4" />
                        </span>
                        <span ref={navigationNextRef} className="p-3 text-gray-600 transition-colors bg-white border rounded-full cursor-pointer hover:bg-main-color hover:text-white">
                            <FaAngleRight className="w-4 h-4" />
                        </span>
                    </div>
                </div>
                <Swiper
                    slidesPerView={1}
                    breakpoints={{
                        640: {
                            slidesPerView: 2,
                        },
                        768: {
                            slidesPerView: 3,
                        },
                    }}
                    spaceBetween={10}
                    autoplay={{
                        delay: 3500,
                        disableOnInteraction: false,
                    }}
                    modules={[Autoplay, Navigation]}
                    navigation={{
                        prevEl: navigationPrevRef.current,
                        nextEl: navigationNextRef.current,
                    }}
                    onBeforeInit={(swiper) => {
                        swiper.params.navigation.prevEl = navigationPrevRef.current;
                        swiper.params.navigation.nextEl = navigationNextRef.current;
                    }}
                    className="promotion-swiper"
                >
                    {data.map((singleData, index) => (
                        <SwiperSlide key={index}>
                            <div className="px-1 py-4 lg:px-3">
                                <CardTour key={index} data={singleData} postType={postType} />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        )
    );
}
